
import Vue from 'vue';
import { TranslateResult } from 'vue-i18n';
import { CourseModel, QuestionModel, ReplyModel } from '@descomplica/dex-models';
import i18n from '../i18n';
import StatusCircle from './StatusCircle.vue';
import { getPaddedDisplayNumber } from '@/helpers/string';

export default Vue.extend({
  components: {
    StatusCircle,
  },
  props: {
    userReplies: {
      type: Array as Vue.PropType<ReplyModel[]>,
      required: true,
    },
    questions: {
      type: Array as Vue.PropType<QuestionModel[]>,
      required: true,
    },
    course: {
      type: Object as Vue.PropType<CourseModel>,
      required: true,
    },
  },
  computed: {
    correctAnswers(): number {
      return this.questions.filter((question) => this.isQuestionCorrect(question)).length;
    },
    grade(): number {
      return (this.correctAnswers * 10) / this.questions.length;
    },
    roundGrade(): number {
      return Math.round(this.grade * 2) / 2;
    },
    text(): TranslateResult {
      return this.grade >= 7 ? i18n.t('niceWork') : i18n.t('letsStudy');
    },
  },
  methods: {
    getPaddedDisplayNumber(n: number) {
      return getPaddedDisplayNumber(n);
    },
    isQuestionCorrect(question: QuestionModel): Boolean {
      const reply = this.getUserQuestionReply(question);
      return !!reply && !!reply.isCorrect();
    },
    getUserQuestionReply(question: QuestionModel): ReplyModel | null {
      return this.userReplies.find((reply) => reply.questionId === question.id) || null;
    },
    getStatusClass(question: QuestionModel): String {
      const isCorrect = this.isQuestionCorrect(question);
      const style = isCorrect ? 'correct' : 'incorrect';
      return `h5 performance__item--${style}`;
    },
  },
});
